import { zodResolver } from '@hookform/resolvers/zod'
import { ScrollArea } from '@radix-ui/react-scroll-area'
import { format } from 'date-fns'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { NumericFormat } from 'react-number-format'
import { useLocalStorage } from '../../../../../remote/local-storage'
import { CashRegisterType } from '../../../../../remote/types/cash-register'
import { CashRegisterInputOutput } from '../../../../../remote/types/cash-register-input-output'
import { Button } from '../../../../components/ui/button'
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '../../../../components/ui/form'
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '../../../../components/ui/select'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../../components/ui/table'
import { Textarea } from '../../../../components/ui/textarea'
import { formatToBRL } from '../../../../utils/formatCurrency'
import { CashRegisterTransactionForm, cashRegisterTransactionSchema } from '../../../../validators/cash-register-transaction'
import { CashRegisterOpenClose } from '../actions/cash-register-open-close'
import { CashRegisterTransaction } from '../actions/cash-register-transaction'
import { LoadCashRegisterId } from '../actions/load-cash-register-id'
import { LoadUsersCashRegister } from '../actions/load-users-cash-register'
interface OpenInfoCashRegisterProps {
  closeModal: () => void
  reload: () => void
  cashRegister: CashRegisterType | null
}

export function OpenInfoCashRegister({ closeModal, cashRegister, reload }: OpenInfoCashRegisterProps) {
  const [modalTransaction, setModalTransaction] = useState({
    open: false,
    type: ''
  })
  const { getProfiles, getId, getName } = useLocalStorage()
  const { data: usersCashRegister } = LoadUsersCashRegister()
  const isProfileAdmin = getProfiles().some((profile: any) => profile == 'ADMIN')

  const { closeCashRegister } = CashRegisterOpenClose()
  const { data, reloadCashRegisterById } = LoadCashRegisterId(cashRegister?.id)
  const { transactionEncrease, transactionDecrease } = CashRegisterTransaction(reloadCashRegisterById)

  const isClosedCashRegister = cashRegister?.statusCaixa == 'FECHADO'

  const isProfiileAdmin = getProfiles().includes('ADMIN')

  const form = useForm<CashRegisterTransactionForm>({
    resolver: zodResolver(cashRegisterTransactionSchema)
  })

  const onSubmit = async (data: any) => {
    if (modalTransaction.type == 'ENTRADA') {
      await transactionEncrease({
        ...data,
        idResponsavel: isProfileAdmin ? cashRegister?.idResponsavel : getId(),
        nomeResponsavel: getName(),
        idCliente: getId(),
        nomeCliente: getName(),
        valor: parseFloat(data.valor)
      })
    } else {
      await transactionDecrease({
        ...data,
        idResponsavel: isProfileAdmin ? cashRegister?.idResponsavel : getId(),
        nomeResponsavel: getName(),
        idCliente: getId(),
        nomeCliente: getName(),
        valor: parseFloat(data.valor)
      })
    }
    form.reset()
    setModalTransaction({ open: false, type: '' })
  }

  useEffect(() => {
    if (isProfiileAdmin && usersCashRegister) {
      form.setValue('nomeCliente', getName())
      form.setValue('idCliente', getId())
    }
  }, [usersCashRegister])

  const totalTransactionsByStatus = (data?: CashRegisterInputOutput[] | null) => {
    if (!data || data.length == 0)
      return {
        totalDecreased: '0',
        totalEncreased: '0',
        totalInCaixa: 0
      }

    const totalDecreased = data.filter((cash) => cash.tipo == 'SAIDA').reduce((acc, cash) => acc + cash.valor, 0)
    const totalEncreased = data.filter((cash) => cash.tipo == 'ENTRADA').reduce((acc, cash) => acc + cash.valor, 0)

    return {
      totalDecreased,
      totalEncreased,
      totalInCaixa: totalEncreased - totalDecreased
    }
  }

  console.log(totalTransactionsByStatus(data))

  return (
    <div className="fixed left-0 top-0 w-full h-full bg-black/30 z-40 flex items-center justify-center gap-2">
      {modalTransaction.open && (
        <div className="bg-white rounded-md shadow-md p-6 w-1/4 h-2/3">
          <h3 className="text-3xl text-[#262626]">{modalTransaction.type == 'ENTRADA' ? 'Entrada de caixa' : 'Retirada de caixa'}</h3>
          <ScrollArea className="h-3/3 overflow-y-auto">
            <Form {...form}>
              <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col gap-2 p-1">
                {isProfileAdmin && (
                  <FormField
                    control={form.control}
                    name="idCliente"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>
                          <span className="text-gray-400">*</span> Funcionário
                        </FormLabel>
                        <FormControl>
                          <Select
                            onValueChange={(data) => {
                              const userCashRegister = usersCashRegister.find((item: any) => item.id === parseInt(data))
                              form.setValue('nomeCliente', userCashRegister.nome)
                              field.onChange(data)
                            }}
                            value={field.value?.toString() || ''}
                            disabled={!isProfiileAdmin}
                          >
                            <SelectTrigger className="">
                              <SelectValue placeholder="Selecione" className="w-full" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectGroup>
                                {usersCashRegister &&
                                  usersCashRegister.map((item: any) => {
                                    return (
                                      <SelectItem value={item.id.toString()} key={item.id}>
                                        <div className="flex gap-2">{item.nome}</div>
                                      </SelectItem>
                                    )
                                  })}
                              </SelectGroup>
                            </SelectContent>
                          </Select>
                        </FormControl>
                        <FormMessage className="text-xs">{form.formState.errors.nomeCliente?.message}</FormMessage>
                      </FormItem>
                    )}
                  />
                )}

                <FormField
                  control={form.control}
                  name="statusHistorico"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>
                        <span className="text-gray-400">*</span> Status
                      </FormLabel>
                      <FormControl>
                        <Select onValueChange={field.onChange} value={field.value || ''}>
                          <SelectTrigger className="">
                            <SelectValue placeholder="Selecione" className="w-full" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectGroup>
                              <SelectItem value={'CONFIRMADO'} key={'CONFIRMADO'}>
                                CONFIRMADO
                              </SelectItem>
                              <SelectItem value={'PENDENTE'} key={'PENDENTE'}>
                                PENDENTE
                              </SelectItem>
                              <SelectItem value={'RECEBIDO'} key={'RECEBIDO'}>
                                RECEBIDO
                              </SelectItem>
                            </SelectGroup>
                          </SelectContent>
                        </Select>
                      </FormControl>
                      <FormMessage className="text-xs">{form.formState.errors.nomeCliente?.message}</FormMessage>
                    </FormItem>
                  )}
                />

                <FormField
                  control={form.control}
                  name="formaPagamento"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>
                        <span className="text-gray-400">*</span> Forma de pagamento
                      </FormLabel>
                      <FormControl>
                        <Select onValueChange={field.onChange} value={field.value || ''}>
                          <SelectTrigger className="">
                            <SelectValue placeholder="Selecione" className="w-full" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectGroup>
                              <SelectItem value={'CARTAO_CREDITO'} key={'CARTAO_CREDITO'}>
                                CARTAO DE CREDITO
                              </SelectItem>
                              <SelectItem value={'DINHEIRO'} key={'DINHEIRO'}>
                                DINHEIRO
                              </SelectItem>
                              <SelectItem value={'PIX'} key={'PIX'}>
                                PIX
                              </SelectItem>
                            </SelectGroup>
                          </SelectContent>
                        </Select>
                      </FormControl>
                      <FormMessage className="text-xs">{form.formState.errors.nomeCliente?.message}</FormMessage>
                    </FormItem>
                  )}
                />

                <FormField
                  control={form.control}
                  name="descricao"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>
                        <span className="text-gray-400">*</span> Descrição
                      </FormLabel>
                      <FormControl>
                        <Textarea className="resize-none" {...field} />
                      </FormControl>
                      <FormMessage className="text-xs">{form.formState.errors.nomeCliente?.message}</FormMessage>
                    </FormItem>
                  )}
                />

                <FormField
                  control={form.control}
                  name="valor"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>
                        <span className="text-gray-400">*</span> Valor
                      </FormLabel>
                      <FormControl>
                        <NumericFormat
                          className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                          thousandSeparator="."
                          decimalSeparator=","
                          prefix="R$ "
                          decimalScale={2}
                          getInputRef={field.ref}
                          {...field}
                          fixedDecimalScale={true}
                        />
                      </FormControl>
                      <FormMessage className="text-xs">{form.formState.errors.valor?.message}</FormMessage>
                    </FormItem>
                  )}
                />

                <div className="flex gap-2 items-end justify-end mt-2">
                  <Button variant={'default'} type="submit" className="bg-acelerafit-green-400 text-muted hover:bg-cashfit-green-200 font-">
                    enviar
                  </Button>

                  <Button
                    variant={'outline'}
                    onClick={() => {
                      setModalTransaction({ open: false, type: '' })
                      form.reset()
                    }}
                  >
                    Fechar
                  </Button>
                </div>
              </form>
            </Form>
          </ScrollArea>
        </div>
      )}

      <div className="bg-white rounded-md shadow-md p-6 w-2/3 h-2/3">
        <h3 className="text-3xl text-[#262626]">Caixa</h3>

        <div className="flex flex-col gap-2 mt-2">
          <p>
            <strong>Data de Abertura:</strong> {cashRegister?.inclusao && format(cashRegister?.inclusao, 'dd/MM/yyyy HH:mm')}
          </p>
          <p>
            <strong>Responsavel abertura: </strong>
            {cashRegister?.nomeResponsavelAbertura || ''}
          </p>
          <div className="flex justify-between">
            <p>
              <strong>Valor Inicial:</strong> {formatToBRL(cashRegister?.inicio.toString() || '0.00')}
            </p>
            <p>
              <strong>Em caixa:</strong> {formatToBRL(totalTransactionsByStatus(data).totalInCaixa.toString() || '0.00')}
            </p>
          </div>
        </div>

        <ScrollArea className="h-2/3 mt-2 overflow-y-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="w-[155px]">Data</TableHead>
                <TableHead>Cliente</TableHead>
                <TableHead>Responsável</TableHead>
                <TableHead className="">Valor</TableHead>
                <TableHead className="">Forma de pagamento</TableHead>
                <TableHead className="">Tipo</TableHead>
                <TableHead className="">Status</TableHead>
                <TableHead className="">Descrição</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data &&
                data.map((item) => (
                  <TableRow key={item.id}>
                    <TableCell className="">{format(item.inclusao, 'dd/MM/yyyy HH:mm')}</TableCell>
                    <TableCell>{item.nomeCliente}</TableCell>
                    <TableCell>{item.nomeResponsavel}</TableCell>
                    <TableCell>{formatToBRL(item?.valor.toString() || '0.00')}</TableCell>
                    <TableCell>{item.formaPagamento}</TableCell>
                    <TableCell>{item.tipo}</TableCell>
                    <TableCell>{item.status ? 'Ativo' : 'Desativado'}</TableCell>
                    <TableCell>{item.descricao}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </ScrollArea>

        <div className="flex justify-end gap-2 mt-4">
          <Button
            variant={'default'}
            className="bg-red-700 hover:bg-red-800 text-cashfit-white"
            disabled={isClosedCashRegister}
            onClick={() => {
              setModalTransaction({
                open: true,
                type: 'SAIDA'
              })
            }}
          >
            Retirada de caixa
          </Button>
          <Button
            variant={'default'}
            className="bg-yellow-400 hover:bg-yellow-500 text-cashfit-white"
            disabled={isClosedCashRegister}
            onClick={() => {
              setModalTransaction({
                open: true,
                type: 'ENTRADA'
              })
            }}
          >
            Entrada de caixa
          </Button>
          <Button
            variant={'destructive'}
            className="bg-acelerafit-green-400 hover:bg-cashfit-green-200 text-muted"
            onClick={() => closeCashRegister(isProfileAdmin ? cashRegister?.idResponsavel : getId(), reload)}
            disabled={isClosedCashRegister}
          >
            Fechar caixa
          </Button>
          <Button variant={'outline'} onClick={closeModal}>
            Fechar
          </Button>
        </div>
      </div>
    </div>
  )
}
